"use client";
import { useRouter } from "@/i18n/routing";
import { Button } from "@/components/custom";
import { useTranslations } from "next-intl";
import { LogoutAction } from "@/lib/actions";
export const LogoutButton = ({ setIsOpen }: { setIsOpen?: (e: boolean) => void }) => {
  const router = useRouter();
  const t = useTranslations();
  const logoutHandler = async () => {
    await LogoutAction();
    if (setIsOpen) setIsOpen(false);
    router.push("/");
  };
  return (
    <form action={logoutHandler}>
      <Button type="submit" className="bg-transparent disabled:opacity-50">
        <span className="icon-icon29 gap-x-5 text-[2rem]" />
        <h1>{t("log-out")}</h1>
      </Button>
    </form>
  );
};
